import React from 'react'
import { Box, Typography, Button, Skeleton } from '@mui/material'
import { useTranslation } from 'react-i18next'
import styles from './FormStatsChart.module.css'

interface StatCardProps {
  title: string
  isLoading?: boolean
  onViewHistory: () => void
  children: React.ReactNode
}

const StatCard = ({ title, isLoading = false, onViewHistory, children }: StatCardProps) => {
  const { t } = useTranslation()

  return (
    <Box p={1} sx={{ height: '100%' }}>
      <Box className={styles.boxHeader}>
        {isLoading ? (
          <Skeleton width={100} />
        ) : (
          <Typography className={styles.chartBoxTitle}>{title}</Typography>
        )}
        <Button
          className={styles.StatsHistory}
          variant="text"
          size="small"
          onClick={onViewHistory}
          disabled={isLoading}
          sx={{ flexShrink: 0 }} /* el botón no se comprime nunca */
        >
          {t('history')}
        </Button>
      </Box>
      <Box className={styles.boxCharts}>{children}</Box>
    </Box>
  )
}

export default StatCard
